<template>
  <b-sidebar :id="htmlId" title="Select an Exam" backdrop-variant="dark" backdrop shadow>
    <button
      v-for="exam in exams"
      :key="exam.id"
      :class="{
        'btn btn-block' : true, 
        'btn-primary bg-site-primary ' : activeExamId == exam.id, 
        'btn-outline-primary' : activeExamId != exam.id && examStatus[exam.id] != 'disabled',
        'btn-outline-secondary`' : examStatus[exam.id] == 'disabled',
      }"
      :disabled="examStatus[exam.id] == 'disabled'"
      type="button"
      @click="changeExam(exam.id)"
      v-html="exam.shortName"
    ></button>
  </b-sidebar>
</template>

<script>
export default {
  props: {
    htmlId: {
      type: String,
      default: () => "test-sidebar",
    },
    exams: {
      type: Array,
      default: () => [],
    },
    examStatus: {
      type: Object,
      default: () => {},
    },
    activeExamId: Number,
  },
  methods: {
    changeExam(examId) {
      this.$emit("changeExam", examId);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>